import React, {useEffect, useState} from "react";
import {
    Tab,
    Accordion,
    Tabs,
    Table, Button
} from "react-bootstrap";
import axios from "axios";
import {Link, useNavigate} from "react-router-dom";
import {useAppUniqueToken} from "../../hooks/useAppUniqueToken";
import {useSanctum} from "react-sanctum";
import SendConfirmation from "../modals/SendConfirmation";
import RemoveConfirmation from "../modals/RemoveConfirmation";

import {loungeData, payloadUser, userData} from "../../config/types";
import UserForm from "../forms/UserForm";
import {forEach} from "react-bootstrap/ElementChildren";
import LoadingSpinner from "./LoadingSpinner";
import UserDetails from "../modals/UserDetails";
import {toast} from "react-custom-alert";
import {useTranslation} from "react-i18next";

import {useToolkit} from "../../hooks/useToolkit";

interface IProps {
    data: userData | null
}

const UsersAccordion = () => {
    const { t } = useTranslation();
    const [isLoading, setLoading] = useState(false)
    const [data, setData] = useState<any>()

    const navigate = useNavigate();

    const { decodeRegione } = useToolkit();

    const [showNewUserModal, setShowNewUserModal] = useState(false);

    const [showRemoveModal, setShowRemoveModal] = useState(false);
    const [customID, setCustomID] = useState<string>()
    const [customToken, setCustomToken] = useState<string>()
    const [showSendModal, setShowSendModal] = useState(false);

    const handleRemove = (id:string, token:string) => {
        setCustomID(id);
        setCustomToken(token);
        setShowRemoveModal(true);
    };

    const handleSend = () => {
        setShowSendModal(true);
    };


    useEffect(() => {
        setLoading(true);
        getUsersData()
            .then(() => setLoading(false));
    }, []);

    const getUsersData = async () => {
        //console.log('getUsersData');

        let usersData = await axios.get('api/users')
            .then(response => {
                //console.log('getLoungeData from axios: ' + response.data.lounge);
                //console.log('getUsersData - response');
                //console.log(response.data);

                setData(response.data);
                //console.log(response.data.lounge);
            }).catch(error => {
                console.log(error);
                toast.error(t('messages.defaultErrorMessage'));
            });
    };

    /*
        const accordionItems = [];
        const getAccordionItems = () => {

            if(data && data.users)
            {
                data.users.forEach((user: any, i: number) => {
                    accordionItems.push(
                        <div key={index}>
                            <h2>name: {employee.name}</h2>
                            <h2>country: {employee.country}</h2>

                            <hr />
                        </div>,
                    );
                });
            }
        }

        *
                    * created_at
                :
                "2023-05-08T08:55:20.000000Z"
                deleted
                :
                0
                deleted_at
                :
                null
                email
                :
                "superhero@gmail.com"
                email_verified_at
                :
                null
                firebase_token
                :
                null
                id
                :
                1
                name
                :
                "Super"
                phone_number
                :
                null
                photo
                :
                null
                role
                :
                "hero"
                status
                :
                "active"
                surname
                :
                "Hero"
                system_role
                :
                "System Super Hero"
                updated_at
                :
                "2023-05-08T08:55:20.000000Z"
                username
                :
                "hero"
        *






        * */


    const renderAccordion_v1 = () => {
        return (
            <Accordion>
            {
                data &&
                data.users.map((user: any, i: number) => (
                    <Accordion.Item eventKey={i.toString()}>
                        <Accordion.Header>
                            {
                                user.status === 'STATUS_ACTIVE' ?
                                    (
                                        <div className="text-success">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                    fill="currentColor" className="bi bi-person-fill-check"
                                                    viewBox="0 0 16 16">
                                                <path
                                                    d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514ZM11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                                                <path
                                                    d="M2 13c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"/>
                                            </svg>
                                        </div>
                                    ) :
                                    (
                                        <div className="text-warning">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                    fill="currentColor" className="bi bi-person-fill-exclamation"
                                                    viewBox="0 0 16 16">
                                                <path
                                                    d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-9 8c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"/>
                                                <path
                                                    d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 1 0V11a.5.5 0 0 0-.5-.5Zm0 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"/>
                                            </svg>
                                        </div>
                                    )
                            }
                            <div> &nbsp;&nbsp;&nbsp;
                                {user.id}
                                &nbsp; - &nbsp;
                                {user.name}
                                &nbsp;&nbsp;&nbsp;
                                {user.surname}
                            </div>
                        </Accordion.Header>
                        <Accordion.Body>
                            <UserForm yourProfile={false} data={user} />
                        </Accordion.Body>
                    </Accordion.Item>
                ))
            }
            </Accordion>
        );
    }

    const renderAccordion_v2 = () => {

        if(!data || !data.users)
            return null;
        
        const groupedByRegion = data.users.reduce((acc: any, user: any) => {
            const region = user.system_region;
            if (!acc[region]) {
                acc[region] = [];
            }
            acc[region].push(user);
            return acc;
        }, {});

        Object.keys(groupedByRegion).forEach(region => {
            groupedByRegion[region].sort((a: any, b: any) => a.surname.localeCompare(b.surname));
        });
        
        //console.log(groupedByRegion);

        let m = (
            <Accordion>
                {
                    groupedByRegion
                        && Object.keys(groupedByRegion).map((region, i) => (    
                            <Accordion.Item eventKey={i.toString()}>
                                <Accordion.Header>
                                    {/* <div className="text-success me-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                fill="currentColor" className="bi bi-person-fill-check"
                                                viewBox="0 0 16 16">
                                            <path
                                                d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514ZM11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                                            <path
                                                d="M2 13c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"/>
                                        </svg>
                                    </div> */}
                                    { 
                                        decodeRegione(region) != ''
                                        ? decodeRegione(region)
                                        : 'Regione non specificata'
                                    }
                                </Accordion.Header>
                                <Accordion.Body>
                                    <Accordion flush>
                                    {   
                                        groupedByRegion[region]
                                        .map((user: any, ii: number) => (
                                            <Accordion.Item eventKey={user.id.toString()}>
                                                <Accordion.Header>
                                                {
                                                    user.status === 'STATUS_ACTIVE' 
                                                    ? (
                                                        <div className="text-success me-2">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                                    fill="currentColor" className="bi bi-person-fill-check"
                                                                    viewBox="0 0 16 16">
                                                                <path
                                                                    d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514ZM11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                                                                <path
                                                                    d="M2 13c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"/>
                                                            </svg>
                                                        </div>
                                                    ) 
                                                    : (
                                                        <div className="text-warning me-2">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                                    fill="currentColor" className="bi bi-person-fill-exclamation"
                                                                    viewBox="0 0 16 16">
                                                                <path
                                                                    d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-9 8c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"/>
                                                                <path
                                                                    d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 1 0V11a.5.5 0 0 0-.5-.5Zm0 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"/>
                                                            </svg>
                                                        </div>
                                                    )
                                                }
                                                <div>
                                                    {user.id}
                                                    &nbsp; - &nbsp;
                                                    {user.name}
                                                    &nbsp;&nbsp;&nbsp;
                                                    {user.surname}
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <UserForm yourProfile={false} data={user} />
                                            </Accordion.Body>
                                            </Accordion.Item>
                                        ))
                                    } 
                                    </Accordion>
                                </Accordion.Body>
                            </Accordion.Item>
                        ))
                }
            </Accordion>
        );

        return (m);
    }



    return (
        isLoading ?
            <LoadingSpinner />
            :
            !showNewUserModal ?
                <>
                <Button variant="outline-success" onClick={() => setShowNewUserModal(true)}>
                    {t('captions.newUser')}
                </Button>
                <br />
                <br />
                { renderAccordion_v2() }
                </> :
                <UserForm yourProfile={false} data={null} />
    );
};

export default UsersAccordion;
